import { render, staticRenderFns } from "./JiraStatusButton.vue?vue&type=template&id=2b95fb00&scoped=true&"
import script from "./JiraStatusButton.vue?vue&type=script&lang=js&"
export * from "./JiraStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./JiraStatusButton.vue?vue&type=style&index=0&id=2b95fb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95fb00",
  null
  
)

export default component.exports